import React, { Component } from "react";
import {
  View,
  Text,
  Image,
  TextInput,
  Button,
  Platform,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
} from "react-native";

import textConstants from "../../constants/textConstants";
import p_Styles from "../paymentScreen/styles";
import OtpScreen from "../OtpScreen/index";
import io from "socket.io-client";
import HocComponent from "../../commonComponents/Hoc";
import CommonButton from "../../commonComponents/Button";
import apis from "../../services/api-services";
import { FAILED_PAYMENT, SUCCESS_PAYMENT } from "../../constants/routePaths";
var socket;
class PaymentOtpScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileotp: "null",
      mobileotperror: "",
      current_room: "",
      timer: null,
      counter: 60,
      customerId: "",
      redirect: "",
      debitCardNumber: "",
      disableSubmit: false,
    };
  }

  //this method call when user click submit button.
  onSubmitClick = () => {
    // onclick Submit button procedure here

    if (this.state.mobileotp.length !== 6) {
      return;
    }
    this.setState({
      disableSubmit: true,
    });
    clearInterval(this.state.timer);
    apis.payment
      .doPayment({
        customerId: this.state.customerId,
        accountNumber: this.state.debitCardNumber.replace(" ", ""),
      })
      .then(() => {
        if (Platform.OS === "web") {
          this.props.history.push({
            pathname: SUCCESS_PAYMENT,
            state: {
              redirect: this.state.redirect,
            },
          });

        } else {
          this.props.navigation.navigate(SUCCESS_PAYMENT, {
            //props to pass here
          });
        }
      })
      .catch((error) => {
        if (Platform.OS === "web") {
          this.props.history.push({
            pathname: FAILED_PAYMENT,
            state: {
              redirect: this.state.redirect,
            },
          });
        } else {
          this.props.navigation.navigate(FAILED_PAYMENT, {
            //props to pass here
          });
        }
      });
  };

  // on load page.
  componentDidMount() {
    this.startTimer();
    let customerId = "";
    let debitCardNumber = "";
    let redirect = "";
    if (Platform.OS === "web") {
      if (this.props.location.state && this.props.location.state.customerId) {
        customerId = this.props.location.state.customerId;
        debitCardNumber = this.props.location.state.debitCardNumber;
        redirect = this.props.location.state.redirect;
      }
    } else {
      customerId = this.props.route.params["state"].customerId;
      debitCardNumber = this.props.route.params["state"].debitCardNumber;
    }

    this.setState({
      customerId,
      debitCardNumber,
      redirect
    });
  }

  // to manage the counter
  manageTimer = () => {
    const { counter } = this.state;

    if (counter === 0) {
      // clearInterval(this.state.timer);
      this.setState({
        counter: 60,
      });
    } else {
      this.setState({
        counter: this.state.counter - 1,
      });
    }
  };

  // to start the counter
  startTimer = () => {
    let timer = setInterval(this.manageTimer, 1000);
    this.setState({ timer });
  };

  // onchange save otp in the state.
  otpSave(value) {
    const val = value.t1 + value.t2 + value.t3 + value.t4 + value.t5 + value.t6;
    this.setState({ mobileotp: val, mobileotperror: "" });
  }
  render() {
    const resResendBtn = `resendBtn_${this.props.measure}`;
    const resOtpErrorMsg = `otpErrorMsg_${this.props.measure}`;
    const viewOtpError = `viewOtpError_${this.props.measure}`;

    return (
      <SafeAreaView style={{ flex: 1 }}>
        <View>
          <ScrollView>
            <View style={p_Styles.outerView}>
              <View style={p_Styles.otpImageView}>
                <Image
                  source={require("../../../assets/images/otp.png")}
                  style={p_Styles.otpImage}
                />
              </View>
              <View style={p_Styles.paymentHeadingView}>
                <Text style={p_Styles.paymentHeading}>
                  {textConstants.otpHeading}
                </Text>
                <Text style={p_Styles.paymentSubHeading}>
                  {textConstants.otpSubText}
                </Text>
              </View>

              <View style={p_Styles.otpView}>
                <OtpScreen
                  {...this.props}
                  otpValue={(value) => this.otpSave(value)}
                  id={this.state.otpid}
                />

                <View style={[p_Styles.viewOtpError, p_Styles[viewOtpError]]}>
                  <Text style={p_Styles.timerText}>
                    {" in " + this.state.counter + "s"}
                  </Text>

                  <TouchableOpacity style={[p_Styles.resendBtn]}>
                    <Text style={p_Styles.redendOtpText}>Resend code?</Text>
                  </TouchableOpacity>
                </View>
              </View>

              <CommonButton
                disabled={
                  this.state.mobileotp.length !== 6 || this.state.disableSubmit
                }
                onPress={() => this.onSubmitClick()}
                ButtonText={"Submit"}
              />
            </View>
          </ScrollView>
        </View>
      </SafeAreaView>
    );
  }
}

export default HocComponent(PaymentOtpScreen);
